<div class="rating-breakdown" *ngIf="viewStatus == ViewStatus.READY">
  <h6 class="title">{{'Rating Breakdown' | translate}}</h6>

  <div [ngClass]="showInRows ? 'rating-list-rows' : 'rating-list'">
    <div [ngClass]="showInRows ? '' : 'rating-item'" *ngFor="let item of ratingData">
      <span class="label">{{ item.label }}</span>
      <div class="rating-container">
        <div class="progress-bar-container" style="flex: 1 1 ; ">
          <div class="h-100 bg-primary rounded" [style.width.%]="(item.rating / 5) * 100"></div>
        </div>
        <span class="rating">{{ item.rating | number:'1.0-1' }}</span>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="viewStatus == ViewStatus.LOADING">
  <div style="flex: 1 1 ; width: 100%;">
    <ng-container *ngFor="let i of [1,2,3,4,5]">
      <div class="d-flex flex-row align-items-center justify-content-between gap-2 my-3">
        <div style="width: 100%;" class="d-flex flex-row justify-content-start gap-2">
          <div style="width: 35%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
          <div style="width: 45%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
        </div>
        <div style="width: 8%;">
          <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
        </div>
      </div>
      <div class="d-flex flex-row align-items-center justify-content-between gap-2 mb-3">
        <div style="width: 100%;" class="d-flex flex-row justify-content-start gap-2">
          <div style="width: 25%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
          <div style="width: 35%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
        </div>
        <div style="width: 5%;">
          <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>